import { configureStore, combineReducers } from "@reduxjs/toolkit";
import savingsFullRatesReducer from "./slice/savingsFullRatesSlice"; // Import the existing reducer
import fdRateDataReducer from "./slice/fdRateDataSlice"; // Import the new reducer
import fcnrRateDataReducer from "./slice/fcnrRateDataSlice";
import authReducer from "./slice/authSlice";
import creditCardReducer from "./slice/creditCardSlice"; // Import the new reducer
import fuelCardReducer from "./slice/fuelCardSlice";

// Combine the reducers
const rootReducer = combineReducers({
  savingsFullRate: savingsFullRatesReducer,
  fdRateData: fdRateDataReducer,
  fcnrRateData: fcnrRateDataReducer,
  auth: authReducer,
  creditCard: creditCardReducer, // Added the new reducer here
  fuelCard: fuelCardReducer,
});

// Configure the store
const store = configureStore({
  reducer: rootReducer,
});

export default store;
